// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Splash {\n    position: fixed;\n    width: 100%;\n    height: 30px;\n\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n\n    margin: auto;\n\n    z-index: 1;\n}\n\n.splash-module {\n    position: absolute;\n    top: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
